
export enum UserStatus {
  initial = 'initial',
  regular = 'regular',
}

export enum UserRole {
  patient = 'patient',
  provider = 'provider',
  superadmin = 'superadmin',
  externalAdmin = 'external_admin'
}

export enum UserRestrictions {
  nonpayment = 'nonpayment'
}

export enum AdminRole {
  superAdmin = 'super_admin',
  admin = 'admin',
  cxAdmin = 'cx_admin',
  cxSpecialist = 'cx_specialist',
  billingSpecialist = 'billing_specialist',
  credentiallingSpecialist = 'credentialling_specialist',
  clinicalSpecialist = 'clinical_specialist',
  higherEdAdmin = 'higher_ed_admin',
}

export const enum SubSystem {
  higherEd = 'higher_ed',
}
